<template>
    <ModalTheme :overlay="false" @close="cancel" :loading="loading || parentLoading">
        <template slot="main">
            <br />
            <br />
            <h1 class="txtCenter" style="font-size: xx-large;">{{ "Create Profile" }}</h1>
            <br />
            <br />
            <div class="form-group row"><TextInputBloc :label="'name'" :required="true" v-model="profile.name" :max-length="99"></TextInputBloc></div>
        </template>
        <template v-if="false" slot="overlay"> </template>
        <template slot="footer">
            <client-color-button @click="save"> {{ "Save Profile" }} </client-color-button>
        </template>
    </ModalTheme>
</template>

<script>
import cacheService from "@/services/cache";
import Multiselect from "vue-multiselect";
import TryLoad from "@/mixins/TryLoadMixin";
import ModalTheme from "@/components/ui/ModalTheme";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import userService from "@/services/user";

export default {
    data: () => ({
        loading: false,
        profile: {
            name: null
        }
    }),
    watch: {},
    props: {
        parentLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        TextInputBloc,
        Multiselect,
        ModalTheme
    },
    mixins: [TryLoad],
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        async save() {
            await this.tryLoad(() => userService.createProfile(this.profile));
            location.reload();
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
</style>



// WEBPACK FOOTER //
// CreateProfile.vue?c7136aa4